import { ESlots, EVisitType, TimeSlotSchema } from '@giffgaff/broadband-common'

import { appointmentUpdate } from '../ChangeInstallDates.container'

export type HandleDateChange = (
  appointmentId: string,
  date: string,
  timeSlot: TimeSlotSchema,
  visitType: EVisitType.IN_HOME | EVisitType.PRE_WORK,
) => void

export type HandleTimeSlotChange = (
  appointmentId: string,
  earliestArrivalTime: string,
  latestArrivalTime: string,
  formattedArrivalTime: string,
  slot: ESlots,
) => void

export type TManagedVisitType = EVisitType.IN_HOME | EVisitType.PRE_WORK

export type UpdatedAppointmentsObj = {
  [EVisitType.PRE_WORK]?: appointmentUpdate
  [EVisitType.IN_HOME]?: appointmentUpdate
}

export type PlanAppointmentLegacyNotes = {
  engineerInstructions?: string
  healthAndSafety?: string
}

export type GroupedPlanAppointmentNotes = {
  [EVisitType.PRE_WORK]?: PlanAppointmentLegacyNotes
  [EVisitType.IN_HOME]?: PlanAppointmentLegacyNotes
}

export enum EOrderStage {
  VALIDATION = 'VALIDATION',
  PRE_WORK = 'PRE_WORK',
  IN_HOME = 'IN_HOME',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export const stagesInOrder = [
  EOrderStage.VALIDATION,
  EOrderStage.PRE_WORK,
  EOrderStage.IN_HOME,
  EOrderStage.COMPLETED,
  EOrderStage.CANCELLED,
] as const

export const isStageBefore = (
  stageToCheck: EOrderStage | undefined,
  stageToCompareAgainst: EOrderStage | undefined,
): boolean => {
  if (!stageToCheck || !stageToCompareAgainst) return false

  const stageToCheckIndex = stagesInOrder.indexOf(stageToCheck)
  const stageToCompareAgainstIndex = stagesInOrder.indexOf(stageToCompareAgainst)

  if (stageToCheckIndex === -1 || stageToCompareAgainstIndex === -1) return false

  return stageToCheckIndex < stageToCompareAgainstIndex
}

export type orderStage = `${EOrderStage}`
